export default "__VITE_ASSET__Ds1S$uMp__"